/**
=========================================================
* Material Dashboard 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { parseUrl } from "query-string";

import useAuthorizedRequest from "components/AuthorizedRequest";
import { Alert, Snackbar } from "@mui/material";

function SupplierEdit() {
  const authorizedReq = useAuthorizedRequest();
  const urlPage = parseUrl(window.location.href);
  const supplierId = urlPage.query.id;
  const navigate = useNavigate();

  // const [status, setStatus] = useState(1);
  // const [supplierName, setSupplierName] = useState("");
  const [snackProps, setSnackProps] = useState({
    message: "",
    severity: "info",
    isOpen: false,
  });
  const [supplierData, setSupplierData] = useState({
    supplier_name: "",
    status: "",
  });

  // const handleStatusChange = (event) => {
  //   setStatus(event.target.value);
  // };

  const handleSnackClose = () => {
    setSnackProps({ ...snackProps, isOpen: false });
  };

  useEffect(() => {
    authorizedReq
      .get(`${process.env.REACT_APP_API_BASE_URL}/supplier/${supplierId}`)
      .then((resSupplier) => {
        // setStatus(resSupplier.data.status);
        // setSupplierName(resSupplier.data.supplier_name);
        setSupplierData({
          supplier_name: resSupplier.data.supplier_name,
          status: resSupplier.data.status,
        });
      })
      .catch((err) => {
        setSnackProps({
          isOpen: true,
          message: err.response.data.message,
          severity: "error",
        });
      });
  }, []);

  const handleUpdateSupplier = () => {
    authorizedReq
      .put(`${process.env.REACT_APP_API_BASE_URL}/supplier/${supplierId}`, supplierData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then(() => {
        setSnackProps({
          isOpen: true,
          message: "Supplier Updated Successfully",
          severity: "success",
        });
        navigate(-1);
      })
      .catch((err) => {
        setSnackProps({
          isOpen: true,
          message: err.response.data.message,
          severity: "error",
        });
      });
  };

  return (
    <DashboardLayout>
      <div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackProps.isOpen}
          onClose={handleSnackClose}
          autoHideDuration={6000}
        >
          <Alert onClose={handleSnackClose} severity={snackProps.severity} sx={{ width: "100%" }}>
            {snackProps.message}
          </Alert>
        </Snackbar>
      </div>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Card>
              <MDBox pt={4} pb={3} px={3}>
                <MDBox
                  component="form"
                  role="form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleUpdateSupplier();
                  }}
                >
                  <MDBox mb={2}>
                    <MDTypography variant="text">Supplier Name</MDTypography>
                    <MDInput
                      type="input"
                      fullWidth
                      placeholder="input product name"
                      value={supplierData.supplier_name}
                      // onChange={(e) =>
                      //   setSupplierData({
                      //     supplier_name: e.target.value,
                      //     status: supplierData.status,
                      //   })
                      // }
                      disabled
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDTypography variant="text">Status</MDTypography>
                    <Select
                      labelId="status"
                      id="status"
                      value={supplierData.status}
                      label="status"
                      variant="standard"
                      defaultValue=""
                      onChange={(e) =>
                        setSupplierData({
                          supplier_name: supplierData.supplier_name,
                          status: e.target.value,
                        })
                      }
                      fullWidth
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </MDBox>
                  <MDBox mt={4} mb={1}>
                    <MDButton
                      variant="gradient"
                      color="info"
                      fullWidth
                      onClick={handleUpdateSupplier}
                    >
                      Update
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SupplierEdit;
